import axios from 'axios';

import { Id, getData } from '@feature/utils';

import { LegalHoliday, LegalHolidayRequest } from './LegalHolidayTypes';

export function list(year?: number) {
  return axios
    .get<LegalHoliday[]>('/travel/legal-holidays', {
      params: { year },
    })
    .then(getData);
}

export function create(request: LegalHolidayRequest) {
  return axios.post<LegalHoliday>('/travel/legal-holidays', request).then(getData);
}

export function update(id: Id, request: LegalHolidayRequest) {
  return axios.put<LegalHoliday>(`/travel/legal-holidays/${id}`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/travel/legal-holidays/${id}`).then(getData);
}
